import React from "react";
import Modal from "./Modal";
import { CheckCircle, FileSpreadsheet } from "lucide-react";

const SuccessModal = ({ isOpen, onClose, processedRows, fileName }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Processing Complete">
      <div className="flex flex-col items-center py-4">
        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-4">
          <CheckCircle className="h-10 w-10 text-green-600" />
        </div>

        <h4 className="text-lg font-semibold text   -green-700 mb-2">Success!</h4>
        <p className="text-blue-800 text-center mb-6">
          All data has been processed successfully.
        </p>

        <div className="bg-blue-50 rounded-lg p-4 w-full mb-4">
          <div className="flex items-start">
            <FileSpreadsheet className="h-5 w-5 text-blue-500 mt-0.5 mr-3" />
            <div>
              <p className="text-sm font-medium text-blue-800">{fileName}</p>
              <p className="text-xs text-blue-600 mt-1">
                {processedRows} rows processed
              </p>
            </div>
          </div>
        </div>

        <button
          onClick={onClose}
          className="px-4 py-2 bg-blue-600 text-white font-medium rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
        >
          Close
        </button>
      </div>
    </Modal>
  );
};

export default SuccessModal;
